import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
// component
import TopBackButton from '@/component/common/top-back-button';
import SFMenu from '@/component/my/sf-menu';
// api
import { loginHistory, loginHistoryResProps } from '@/api/server/user/read';
import { responseProps } from '@/api/server/response';
import ErrorRes from '@/api/server/ErrorRes';
// lib
import { SFPalette } from '@/lib/color';

export default function LoginHistory() {
  const { t } = useTranslation();
  const [history, setHistory] = useState<loginHistoryResProps[]>([]);
  useEffect(() => {
    (async () => {
      const re: responseProps = await loginHistory();
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setHistory(re.data.list);
    })();

    return () => {};
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title={t('title.loginHistory')}
        boxProps={{
          mb: 4,
        }}
      />
      <Typography
        variant="body1"
        sx={{
          color: SFPalette.grey2,
          wordBreak: 'keep-all',
        }}
        mb={1}
      >
        {t('message.noticeLoginHistory')}
      </Typography>
      <SFMenu.Menu>
        <Divider sx={{ mb: 2 }} />
        {history.map((item: loginHistoryResProps) => (
          <Fragment key={item.seq}>
            <SFMenu.BetweenItem
              leftContent={
                <Stack>
                  <Typography variant="subtitle2">{item.login_dt}</Typography>
                  {/* ip가 내부망으로 되어 있어서 있으나 마나 함 */}
                  {/* <Typography sx={{ color: SFPalette.lightGrey2 }} variant="body2">
                    {item.ip}
                  </Typography> */}
                </Stack>
              }
              rightContent={
                <Stack>
                  <Typography variant="subtitle2">{item.country}</Typography>
                  <Typography sx={{ color: SFPalette.lightGrey2 }} variant="body2">
                    {item.model_nm ? item.model_nm : item.browser}
                  </Typography>
                </Stack>
              }
            />
            <Divider sx={{ my: 2 }} />
          </Fragment>
        ))}
      </SFMenu.Menu>
    </Container>
  );
}
